import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    staticClass: "wrapper-setting-modal",
    attrs: {
      "data-sign": "product_wrapper_setting_modal",
      "width": 800,
      "title": _vm.rowData.title
    },
    on: {
      "cancel": _vm.handleClose
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-alert', {
    staticClass: "mb-10",
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_c('template', {
    slot: "description"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-8px"
    }
  }, [_vm._v(_vm._s(_vm.t('您可使用此功能，修改成功后系统针对商品包材的处理逻辑包括以下2种：')))]), _c('div', [_vm._v(_vm._s(_vm.t('1. 如在【商品包材】列表中不存在的SKU，系统将按照您配置的区域仓包材策略；')))]), _c('div', [_vm._v(_vm._s(_vm.t('2. 已维护商品包材规则的且SKU（在商品包材列表中存在的SKU），商品包材规则不变。')))])])], 2), _c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "data-sign": "product_wrapper_setting_form",
      "layout": "vertical",
      "rules": _vm.formDataRule,
      "model": _vm.formData
    }
  }, [_c('a-tabs', {
    on: {
      "change": _vm.handleTabChange
    },
    model: {
      value: _vm.currentWarehouseCode,
      callback: function ($$v) {
        _vm.currentWarehouseCode = $$v;
      },
      expression: "currentWarehouseCode"
    }
  }, _vm._l(_vm.rowData.warehouseList || [], function (item) {
    return _c('a-tab-pane', {
      key: item.warehouse_code,
      attrs: {
        "tab": item.warehouse_name_text
      }
    });
  }), 1), _c('a-form-model-item', {
    staticClass: "mt-20",
    attrs: {
      "fbu-analyse-name": $t("\u662F\u5426\u9700\u8981\u5305\u6750"),
      "prop": "need_package",
      "label": _vm.t('是否需要包材')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择')
    },
    on: {
      "change": _vm.handleNeedPackageChange
    },
    model: {
      value: _vm.formData.need_package,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "need_package", $$v);
      },
      expression: "formData.need_package"
    }
  }, _vm._l(_vm.packageisNeedEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")]);
  }), 1)], 1), _vm.formData.need_package === _vm.$enum.common.Enabled.YES ? _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5305\u6750\u5F52\u5C5E"),
      "prop": "sku_wrapper_source",
      "label": _vm.t('包材归属')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择包材归属')
    },
    on: {
      "change": _vm.handleSkuWrapperSourceChange
    },
    model: {
      value: _vm.formData.sku_wrapper_source,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "sku_wrapper_source", $$v);
      },
      expression: "formData.sku_wrapper_source"
    }
  }, _vm._l(_vm.skuWrapperSourceEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "disabled": item.value === _vm.$enum.product.SkuWrapperSourceEnum.PRIVATE && !_vm.isProductPrivateWrapper
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")]);
  }), 1)], 1) : _vm._e(), _vm.formData.need_package === _vm.$enum.common.Enabled.YES ? _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5305\u6750\u9009\u62E9\u65B9"),
      "prop": "package_select",
      "label": _vm.t('包材选择方')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择包材选择方')
    },
    on: {
      "change": _vm.handlePackageSelectChange
    },
    model: {
      value: _vm.formData.package_select,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "package_select", $$v);
      },
      expression: "formData.package_select"
    }
  }, _vm._l(_vm.packageSelectEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")]);
  }), 1)], 1) : _vm._e(), _vm.formData.package_select === _vm.$enum.product.PackageSelectEnum.SELF ? _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5305\u6750\u8981\u6C42"),
      "prop": "package_req",
      "label": _vm.t('包材要求')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择包材要求')
    },
    on: {
      "change": _vm.handlePackageReqChange
    },
    model: {
      value: _vm.formData.package_req,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "package_req", $$v);
      },
      expression: "formData.package_req"
    }
  }, _vm._l(_vm.packageReqEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")]);
  }), 1)], 1) : _vm._e(), _vm.formData.package_select === _vm.$enum.product.PackageSelectEnum.SELF ? _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5305\u6750\u7F16\u7801"),
      "prop": "package_code",
      "label": _vm.t('包材编码')
    }
  }, [_c('my-auto-complete', {
    attrs: {
      "allow-clear": ""
    },
    on: {
      "change": _vm.handlePackageCodeChange
    },
    model: {
      value: _vm.formData.package_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "package_code", $$v);
      },
      expression: "formData.package_code"
    }
  }, [_c('template', {
    slot: "dataSource"
  }, _vm._l(_vm.wrapperOptionList, function (item) {
    return _c('a-select-option', {
      key: item.package_code,
      attrs: {
        "value": item.package_code
      }
    }, [_vm._v(_vm._s(item.package_code) + "[" + _vm._s(item.package_name) + "]")]);
  }), 1)], 2)], 1) : _vm._e()], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-permission": "product_wrapper_add_cancel",
      "id": "product_wrapper_add_cancel",
      "data-sign": "product_wrapper_setting_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "data-permission": "product_wrapper_add_save",
      "id": "product_wrapper_add_save",
      "data-sign": "product_wrapper_setting_submit",
      "type": "primary",
      "fbu-analyse-name": $t("\u4FDD\u5B58")
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(_vm._s(_vm.t('保存')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };